<template>
  <div class="box11">
    <pageTitle
      title="好就业、好未来  成就品牌好口碑"
      text="学生认可才是好的口碑"
      titleColor="#191c47"
      titColor="#666666"
    />
    <studentEvaluation
      :evaluateData="evaluateData"
      :styleData="styleData"
      @provideIndex="provideIndex"
      scrollColor="#c9c7ff"
      blockColor="#5d5bf5"
    />
    <previewImage
      ref="previewImage"
      :clickedIndex="clickedIndex"
      :isPreview="isPreview"
      type="img"
      :targetImg="evaluateData[this.cur].imgUrlList[this.clickedIndex].img"
      @close="close"
    />
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import previewImage from "../common/previewImage.vue";
import studentEvaluation from "../common/student-evaluation.vue";
export default {
  components: {
    pageTitle,
    studentEvaluation,
    previewImage,
  },

  data() {
    return {
      clickedIndex: 0,
      isPreview: false,
      cur: 0,
      evaluateData: [
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/pm/box11/1.png"),
              id: 1,
            },
            {
              img: require("../../../assets/coursePage/pm/box11/2.png"),
              id: 2,
            },
          ],
        },
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/pm/box11/3.png"),
              id: 3,
            },
            {
              img: require("../../../assets/coursePage/pm/box11/4.png"),
              id: 4,
            },
          ],
        },
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/pm/box11/5.png"),
              id: 5,
            },
            {
              img: require("../../../assets/coursePage/pm/box11/6.png"),
              id: 6,
            },
          ],
        },
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/pm/box11/7.png"),
              id: 7,
            },
            {
              img: require("../../../assets/coursePage/pm/box11/8.png"),
              id: 8,
            },
          ],
        },
      ],

      titleColor: "#3E4F48",

      styleData: {
        imgBorder: "border: 0.053333rem solid #999cff;",
        imgHoverBorder: "border: 0.053333rem solid #999cff;",
      },
    };
  },
  methods: {
    provideIndex(index, index1) {
      this.clickedIndex = index1;
      this.cur = index;
      this.isPreview = true;
    },
    close() {
      this.isPreview = false;
      this.clickedIndex = 0;
      this.cur = 0;
      // this.imageUrl = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.box11 {
  padding: 80px 0 88px;
  width: 100%;
  background: url("../../../assets/coursePage/pm/box11/bg.jpg") no-repeat;
  background-size: cover;
}
</style>
